<div class="confirm-transfer d-flex flex-column justify-content-between">
    <div class="p2p-header p-4">
        <div class="d-flex justify-content-start align-items-center cursor-pointer" (click)="cancel()">
            <mat-icon fontIcon="arrow_back"></mat-icon>
            <span>Back</span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center my-4">
            <div class="icon">
                <mat-icon svgIcon="wallet-money"></mat-icon>
            </div>
            <h2>Peer to Peer Money</h2>
        </div>
    </div>

    <div class="transaction-box mx-4 mb-3">
        <div class="d-flex justify-content-between align-items-center">
            <div class="amount-title">Amount</div>
        </div>
        <div class="amount-value">
            {{ amount | number : amountDecimals }} <span class="currency-sub-text">{{ currency }}</span>
        </div>
        <hr />
        <div class="sub-text">
            Receiver will receive: <strong>{{ amount | number : amountDecimals }} {{ currency }}</strong>
        </div>
    </div>

    <div class="sender-receiver-info mb-3 mx-4">
        <div class="header-bg-title p-2">Sender</div>
        <div class="d-flex justify-content-between align-items-center p-2">
            <div>
                <p class="mb-0 fw-bold sender-receiver-text">{{ senderInfo?.name }}</p>
                <p class="mb-0 sender-receiver-sub-text">{{ formattedSenderMobile }}</p>
            </div>
            <div class="d-flex align-items-center">
                <span class="text-muted me-1">Wallet:</span>
                <img [src]="'/assets/currency-flags/' + currency + '-flag.svg'" [alt]="currency" class="currency-flag me-1" />
                <span class="fw-bold text-dark">{{ currency }}</span>
            </div>
        </div>
    </div>

    <div class="sender-receiver-info mb-3 mx-4">
        <div class="header-bg-title p-2">Receiver</div>
        <div class="d-flex justify-content-between align-items-center p-2">
            <div>
                <p class="mb-0 fw-bold sender-receiver-text">{{ maskedRecipientName }}</p>
                <p class="mb-0 sender-receiver-sub-text">{{ formattedRecipientMobile }}</p>
            </div>
            <div class="d-flex align-items-center">
                <span class="text-muted me-1">Wallet:</span>
                <img [src]="'/assets/currency-flags/' + currency + '-flag.svg'" [alt]="currency" class="currency-flag me-1" />
                <span class="fw-bold text-dark">{{ currency }}</span>
            </div>
        </div>
    </div>

    <div class="footer d-flex justify-content-start align-items-center p-4">
        <button class="btn-primary rounded-pill me-2" mat-raised-button (click)="confirmTransfer()">Confirm Transfer</button>
        <button class="btn-secondary rounded-pill" mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</div>
